import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BillingAddress } from '../interfaces/billing-address';
import { BillingWallet } from '../interfaces/billing-wallet';

@Injectable({
     providedIn: 'root'
})
export class BillingService {
     walletURL: string = '';

     constructor(private http: HttpClient) { }

     createCDBBillingAccount(customerId:string, email:string, address :BillingAddress,lang: string = 'en') {
          const CdbUrl = environment.APP_PSP_CDB_URL;
          const createInfo:BillingWallet = {
              CdbUrl: CdbUrl,
              Token: this.uuidv4(),
              UserHostName: "",
              CustomerId: customerId,
              CustomerEmail: email,
              NotificationCallbackUrl: '---',
              Options: { 
                  CcEnabled: true, 
                  AchEnabled: (address.Country === 'USA' ? true : false), 
                  DisplayCancelButton: true,  
                  Localization: lang.toLowerCase(),
                  ForeignAddressesEnabled:true
              },
              Address: address
          }
  
          
  
          const walletURL = `${environment.APP_API_URL}/api/v1/Wallet/GetIframeURL`;
          return this.http.post(walletURL,createInfo,{ responseType: 'text' })
          .pipe(
               map((response: any) =>
                    response as any),
               catchError((error : string) => {
                    console.error(error);
                    return error;
               })
          );
  
  
          
      }

      updateDefaultBilling(customerId:string, setTo: string = '') {
          const walletURL = `${environment.APP_API_URL}/api/v1/BillingAccount/Update/${customerId}`;
          return this.http.get(walletURL)
               .pipe(
                    map((response: any) =>
                         response.data as any),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );

      }

      private uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
              const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
              return v.toString(16);
          });
      }
}
